import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { NHAPipesModule } from '@nha/pipes';
import { NHASimpleListComponent } from './simple-list.component';
import { ScrollingModule } from '@angular/cdk/scrolling';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		RouterModule,
		ScrollingModule,
		MatButtonModule,
		MatIconModule,
		NHAPipesModule,
		NHASimpleListComponent
	],
	exports: [NHASimpleListComponent]
})
export class NHASimpleListModule {}
